import { useCallback, useState } from "react";
import { api } from "@/lib/api";
import { TrackList } from "@/components/tracks/TrackList";
import { usePlayer } from "@/hooks/usePlayer";
import type { Track } from "@/types/types";

interface Radio { radio_id: string; tracks: Track[] }

export function RadioPage() {
  const p = usePlayer();
  const [seed, setSeed] = useState("");
  const [tracks, setTracks] = useState<Track[]>([]);

  const startArtist = useCallback(async () => {
    if (!seed) return;
    const r = await api<Radio>("/api/radio", { method: "POST", body: JSON.stringify({ kind: "artist", seed_id: seed }) });
    setTracks(r.tracks);
    void p.play(r.tracks, 0);
  }, [seed, p]);

  return (
    <div>
      <h1>Radio</h1>
      <div className="row" style={{ gap: 8, marginBottom: 20 }}>
        <input
          placeholder="ID artiste"
          value={seed}
          onChange={(e) => setSeed(e.target.value)}
          style={{ padding: 10, borderRadius: 8, background: "var(--bg-elev)", border: "1px solid var(--line)" }}
        />
        <button className="btn primary" onClick={() => void startArtist()}>Lancer</button>
      </div>
      <TrackList tracks={tracks} />
    </div>
  );
}
